import {
  ADMIN_FRONTEND_VERSION,
  PORTAL_FRONTEND_VERSION,
} from '@repo/constants';
import { useAppType, useIsMobile, useUserDetailsQuery } from '@repo/lib';
import { AppType } from '@repo/types';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  LogoAcgIcon,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@ui/components';
import { ChevronsUpDown, CrownIcon, Moon, Sun, UsersIcon } from 'lucide-react';

export const Organization = () => {
  const isMobile = useIsMobile();

  const appType = useAppType();

  const { user } = useUserDetailsQuery();

  const permissions = user?.permissions;

  const version =
    appType === AppType.PORTAL
      ? PORTAL_FRONTEND_VERSION
      : ADMIN_FRONTEND_VERSION;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
              size="lg"
            >
              <div className="flex size-8 min-w-8 items-center justify-center rounded-lg bg-primary">
                <LogoAcgIcon className="size-6 min-w-6 text-white" />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-bold text-primary">
                  ACG Group
                </span>
                <span className="truncate text-xs">{`v${version}`}</span>
              </div>
              <ChevronsUpDown className="ml-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="z-[10000] w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? 'bottom' : 'right'}
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <div className="flex size-8 items-center justify-center rounded-lg bg-primary">
                  <LogoAcgIcon className="size-6 text-white" />
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-bold text-primary">
                    ACG Group
                  </span>
                  <span className="truncate text-xs">v{version}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <Sun className="mr-2 size-4 dark:hidden" />
              <Moon className="mr-2 hidden size-4 dark:block" />
              Toggle theme
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                window.open('https://acg.group/', '_blank');
              }}
            >
              <CrownIcon className="mr-2 size-4 " />
              ACG Website
            </DropdownMenuItem>
            {permissions?.view_env_client && (
              <DropdownMenuItem
                onClick={() => {
                  window.open('https://client.acg.group', '_blank');
                }}
              >
                <UsersIcon className="mr-2 size-4 " />
                Client Portal
              </DropdownMenuItem>
            )}

            {permissions?.view_env_portal && appType !== AppType.PORTAL && (
              <DropdownMenuItem
                onClick={() => {
                  window.open(`${import.meta.env.VITE_BACKEND_HOST}`, '_blank');
                }}
              >
                <UsersIcon className="mr-2 size-4 " />
                Management Portal
              </DropdownMenuItem>
            )}

            {permissions?.view_env_admin && appType !== AppType.ADMIN && (
              <DropdownMenuItem
                onClick={() => {
                  window.open(
                    `${import.meta.env.VITE_BACKEND_HOST?.replace(
                      'portal',
                      'admin',
                    )}`,
                    '_blank',
                  );
                }}
              >
                <UsersIcon className="mr-2 size-4 " />
                Admin Env
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
